// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"58f9c1c6","464":"85da1981","735":"d302f965"}[chunkId] + ".chunk.js";
};